var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00005 0.907715V3.30771C8.00005 3.74954 8.35823 4.10771 8.80005 4.10771H11.2001M3.60005 4.10771H5.20005M3.60005 6.50771H8.40006M3.60005 8.90771H8.40006M10.0001 2.10771C9.644 1.78914 9.27453 1.4113 9.04129 1.1659C8.88608 1.0026 8.67163 0.907715 8.44634 0.907715H2.39987C1.51621 0.907715 0.799872 1.62405 0.799867 2.50771L0.799805 12.1077C0.799799 12.9913 1.51614 13.7077 2.3998 13.7077L9.59983 13.7077C10.4835 13.7077 11.1998 12.9914 11.1998 12.1077L11.2 3.62627C11.2001 3.42171 11.122 3.22507 10.98 3.0778C10.7175 2.80548 10.2791 2.35739 10.0001 2.10771Z",
    stroke: "#1B4DFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/IconInfo.788174acfbc1318718823e64b47ed122.svg";
export { ForwardRef as ReactComponent };